<template>
  <div class="container">
    <QueryFrame @handlePage='handlePage' @handlePageSize='handlePageSize' :disablePage='disablePage'
      :current='page' :count='count'>
      <div slot="queryParams" class="form">
        <div class="queryContainer">
          <!-- <div class="queryItem">
            <label>查询日期:</label>
           <timeStampDatePicker :maxlength='100' placeholder='请输入' class="item"
              clearable v-model.trim='query.usageStartTime'></timeStampDatePicker>
          </div> -->
          <div class="queryItem">
            <label>选择药品:</label>
            <goodsSelect :maxlength='100' placeholder='请输入' class="item" clearable
              v-model.trim='query.goodsName' ref="goodsSelect"></goodsSelect>
          </div>

         <div class="queryItem">
            <label>截止时间:</label>
            <timeStampDatePicker v-model="query.reportQueryEndTime" placeholder='请选择' class="item" clearable></timeStampDatePicker>
          </div>
         <div class="queryItem">
            <label>药店类型:</label>
            <lk-select v-model="query.storeTypeCode" placeholder='请选择' class="item" >
              <lk-option v-for="(item,i) in storeTypeList" :key="i" :value='i'>{{item}}</lk-option>
            </lk-select>
          </div>

          <!--  <div class="queryItem" v-if="roleType!==2">
            <label>创建门店:</label>
            <StoreListSelect :maxlength='100' placeholder='请输入' class="item" clearable
              v-model.trim='query.createStoreIdList'></StoreListSelect>
          </div>
          <div class="queryItem" v-if="roleType!==2">
            <label>购药门店:</label>
            <StoreListSelect :maxlength='100' placeholder='请输入' class="item" clearable
              v-model.trim='query.buyStoreIdList'></StoreListSelect>
          </div> -->
          <div class="queryItem">
            <lk-button class="mr" type='primary' @click="handleSearch">查询</lk-button>
            <lk-button @click="clear">重置</lk-button>
          </div>
        </div>
      </div>
      <div slot="table">
        <!-- <div class="mb16">
          <DownloadButton @on-click="download" v-if="handlePermission('patientExport')">
          </DownloadButton>
        </div> -->
        <lk-table border :columns='columns' :data='tableData'></lk-table>
      </div>
    </QueryFrame>

  </div>
</template>

<script>
import QueryFrame from '@/components/frame/QueryFrame.vue';
// import supplier from '../../services/supplier';
import base from '../../services/base';
// import DtpDatePicker from '../../components/DtpDatePicker.vue';
import utils from '../../libs/utils';
import mapState from '../../mixins/mapState'; // 鉴权
import queryMixins from '../../mixins/queryMixins';
// import DownloadButton from '../../components/download/DownloadButton';
import goodsSelect from '../../components/tools/goodsSelect.vue';
// import location from '../../components/location';

// const { hospital } = base;
export default {
  name: 'PatientCountList',
  mixins: [mapState, queryMixins],
  components: {
    QueryFrame,
    // DownloadButton,
    goodsSelect,
    // location,
  },
  computed: {
    storeTypeList() {
      return this.$store.getters.getStoreTypeList;
    },
  },
  data() {
    return {


      columns: [
        {
          // title: '类型',
          type: 'expand',
          render: (h, { row }) => h('lk-table', {
            props: {
              columns: this.expandCols,
              data: row.patientRebuyReasonList,
            },
          }),
          width: 80,
        },
        {
          title: '类型',
          key: 'type',
          minWidth: 116,
        },
        {
          title: '患者数量',
          key: 'count',
          minWidth: 116,
        },

        // {
        //   title: '进行中的任务',
        //   key: 'createStoreName',
        //   minWidth: 116,
        // },
        // {
        //   title: '创建门店',
        //   key: 'createStoreName',
        //   minWidth: 116,
        // },
        // {
        //   title: '创建门店',
        //   key: 'createStoreName',
        //   minWidth: 116,
        // },


        // {
        //   title: '操作',
        //   key: 'action',
        //   width: 200,
        //   fixed: 'right',
        //   render: (h, params) => h('div', [
        //     (this.handlePermission('patientCheck') ? h(
        //       'lk-button', {
        //         props: {
        //           type: 'text',
        //           size: 'small',
        //         },
        //         on: {
        //           click: () => {
        //             this.$router.push({ name: 'patientCheck', params: { id: params.row.id } });
        //           },
        //         },
        //       }, '查看',
        //     ) : null), (this.handlePermission('patientEdit') ? h(
        //       'lk-button', {
        //         props: {
        //           type: 'text',
        //           size: 'small',
        //         },
        //         on: {
        //           click: () => {
        //             this.$router.push({ name: 'patientEdit', params: { id: params.row.id } });
        //           },
        //         },
        //       }, '编辑',
        //     ) : null),
        //   ]),
        // },
      ],


      query: {
        duration: [], storeTypeCode: '1',
      },

      tableData: [],
      expandCols: [
        { title: '未复购原因', key: 'reason' },
        { title: '患者数量', key: 'patientNum' },
        { title: '占比', key: 'numPercentStr' },
      ],

    };
  },
  methods: {


    // download() {
    //   const params = this.formatParams(this.params);
    //   params.page = 0;
    //   params.size = 0;
    //   delete params.encrypt;
    //   // params.duration && ([params.createTimeStart, params.createTimeEnd] = params.duration);
    //   // delete params.duration;
    //   params.queryCondition = utils.getQueryCondition('.queryContainer');
    //   // params.type = 2;
    //   base.patient.downloadPatientList(params).then((res) => {
    //     // utils.downLoadExcel(res, '处方药销售记录查询');
    //     if (res.status !== 200) {
    //       this.$Message.error(res.error);
    //     }
    //   }).catch((err) => {
    //     utils.handleError(err);
    //   });
    // },

    clear() {
      this.query = {
        storeTypeCode: '1',
        // duration: [],
      };

      this.$refs.goodsSelect.clear();
    },
    formatParams(params) {
      const temp = utils.deepClone(params);
      temp.page = this.page;
      temp.size = this.size;
      // if (temp.duration.length) {
      //   temp.createTimeStart = temp.duration[0];
      //   temp.createTimeEnd = temp.duration[1];
      // }
      return temp;
    },
    getData() {
      // this.params.page = this.page;
      // this.params.size = this.size;

      this.params = this.formatParams(this.query);
      // this.params.encrypt = true;
      if (!this.query.goodsName) {
        this.$Message.error('请选择商品');
        return;
      }
      base.patient.getPatientRebuyCount(this.params).then((res) => {
        if (res.data.status === 200) {
          this.tableData = [];
          this.count = res.data.data.count;
          this.tableData = res.data.data.list.map((item) => {
            if (!item.patientRebuyReasonList.length) {
              item._disableExpand = true;
            }
            return item;
          });
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },


  },
  mounted() {

    // this.$set(this.query, 'usageStartTime', new Date().getTime());

  },
};

</script>

<style lang="less" scoped>


</style>
